import React from "react";
import logo from "../assets/logo.jpg";

export default function TelaInicial({ onEntrar, onComecarGratis }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f7fb",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "430px",
          background: "#ffffff",
          borderRadius: "24px",
          padding: "32px 24px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <img
          src={logo}
          alt="Invexa"
          style={{
            width: "160px",
            maxWidth: "100%",
            marginBottom: "24px",
          }}
        />

        <h1
          style={{
            fontSize: "30px",
            lineHeight: "36px",
            color: "#0f172a",
            margin: "0 0 14px 0",
            fontWeight: "800",
          }}
        >
          Controle total do seu negócio em um só lugar
        </h1>

        <p
          style={{
            fontSize: "16px",
            lineHeight: "24px",
            color: "#475569",
            margin: "0 0 28px 0",
          }}
        >
          Gerencie estoque, matéria-prima, vendas e lucro de forma simples e inteligente.
        </p>

        <div
          style={{
            textAlign: "left",
            background: "#f8fafc",
            borderRadius: "16px",
            padding: "18px",
            marginBottom: "28px",
          }}
        >
          <p style={{ margin: "0 0 12px 0", color: "#0f172a", fontWeight: "600" }}>
            📦 Controle de estoque em tempo real
          </p>
          <p style={{ margin: "0 0 12px 0", color: "#0f172a", fontWeight: "600" }}>
            💰 Cálculo automático de lucro
          </p>
          <p style={{ margin: "0", color: "#0f172a", fontWeight: "600" }}>
            📊 Relatórios simples e rápidos
          </p>
        </div>

        <button
          onClick={onComecarGratis}
          style={{
            width: "100%",
            height: "52px",
            border: "none",
            borderRadius: "14px",
            background: "#22c55e",
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: "700",
            cursor: "pointer",
            marginBottom: "12px",
          }}
        >
          Começar grátis
        </button>

        <button
          onClick={onEntrar}
          style={{
            width: "100%",
            height: "52px",
            borderRadius: "14px",
            border: "1px solid #cbd5e1",
            background: "#ffffff",
            color: "#0f172a",
            fontSize: "16px",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          Já tenho conta
        </button>
      </div>
    </div>
  );
}